<template>
  <div class="selector-option">
    <img v-if="imageUrl" :src="imageUrl" class="thumbnail" />
    {{ label }}
  </div>
</template>

<script>
export default {
  name: "SelectorOption",
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.selector-option {
  @apply flex items-center whitespace-no-wrap;
}
.thumbnail {
  @apply rounded m-0 mr-2 border border-grey-light h-auto;

  width: 30px;
}
</style>
